import(/* webpackMode: "eager" */ "/codebuild/output/src1828450349/src/apps/fanychance/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1828450349/src/apps/fanychance/src/components/form/LinkButton/LinkButton.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1828450349/src/apps/fanychance/src/features/faq/components/FaqTagList/FaqTagList.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1828450349/src/apps/fanychance/src/features/faq/components/FaqDetail/FaqDetail.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1828450349/src/node_modules/next/dist/client/link.js");
